export default __webpack_public_path__ + "static/media/xmost_innovpany-01-1024x538-1.png.pagespeed.ic.BwHO0PUJpD.d071cb98.png";